module.exports = __webpack_public_path__ + "static/media/slider-l4-360.736801fd.webp";